/* 🤖 this file was generated by svg-to-ts */
export const siriusTiktoklogo: {
  name: 'tiktoklogo';
  data: string;
} = {
  name: 'tiktoklogo',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M21 6.75a4.505 4.505 0 0 1-4.5-4.5.75.75 0 0 0-.75-.75H12a.75.75 0 0 0-.75.75v12.375a1.875 1.875 0 1 1-2.678-1.695.75.75 0 0 0 .428-.678V8.25a.75.75 0 0 0-.881-.739c-3.346.596-5.869 3.655-5.869 7.114a7.125 7.125 0 1 0 14.25 0v-3.723A9.68 9.68 0 0 0 21 12a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75Zm-.75 3.716a8.173 8.173 0 0 1-4.062-1.514.75.75 0 0 0-1.188.61v5.063a5.625 5.625 0 1 1-11.25 0c0-2.428 1.56-4.606 3.75-5.4v2.594a3.374 3.374 0 1 0 5.25 2.806V3h2.297a6.013 6.013 0 0 0 5.203 5.203v2.263Z" fill="currentColor"/></svg>`
};
